import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IoChevronBack } from "react-icons/io5";

import { ProfileCard } from "./ProfileCard";
import { BookingInformationCard } from "./BookingInformationCard";
import { UserInformationCard } from "./UserInformationCard";
import { WebsiteCard } from "./WebsiteCard";
import ChannelsAndAppsNew from "./ChannelsAndAppsNew";
import PrivacySettings from "./PrivacySettings";
import VoiceCloning from "./VoiceCloning";
import { Subscription } from "./subscription/Subscription";
import YourBusinessDescription from "../YourBussiness/YourBusinessDescription";
 
import { getBookingTimeThunk } from "../../redux/slices/profileSlice/asyncthunk";
import { useAppDispatch } from "../../hooks/redux/useRedux";

export default function Settings({ initialTab = "user-info" }) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(initialTab);
  // Mobile master-detail: false = show the profile menu, true = show the
  // selected tab's content full-screen. Ignored at lg+ (both panes show).
  const [mobileDetailOpen, setMobileDetailOpen] = useState(false);

  const handleSelectTab = (tab: string) => {
    setActiveTab(tab);
    setMobileDetailOpen(true);
  };

  useEffect(() => {
    dispatch(getBookingTimeThunk());
  }, [dispatch]);

  return (
    <div className="flex flex-col lg:flex-row w-full min-h-screen bg-[#F5F6FA] p-3 sm:p-4 gap-6">
      <div
        className={`${
          mobileDetailOpen ? "hidden" : "block"
        } lg:block w-full lg:w-auto lg:shrink-0 lg:self-start lg:sticky lg:top-4`}
      >
        <ProfileCard activeTab={activeTab} setActiveTab={handleSelectTab} />
      </div>

      <div
        className={`${
          mobileDetailOpen ? "flex" : "hidden"
        } lg:flex flex-col flex-1 gap-6 min-w-0`}
      >
        <button
          type="button"
          onClick={() => setMobileDetailOpen(false)}
          className="lg:hidden flex items-center gap-1 text-sm font-medium text-[#020637] -mb-1 w-fit px-1 py-1.5"
        >
          <IoChevronBack className="h-5 w-5" />
          {t("common.back", "Back")}
        </button>

        {activeTab === "user-info" && (
          <>
            <UserInformationCard />
            <YourBusinessDescription />
            <BookingInformationCard />
            <WebsiteCard />
          </>
        )}

        {/* Subscriptions */}
        {/* {activeTab === "subscriptions" && <Subscriptions />} */}

        {/* Voice Cloning */}
        {activeTab === "voice-cloning" && <VoiceCloning />}

        {/* Channels & Apps */}
        {activeTab === "channels" && <ChannelsAndAppsNew />}

        {/* Privacy Settings */}
        {activeTab === "privacy" && <PrivacySettings />}
        {activeTab === "subscription" && <Subscription />}
      </div>
    </div>
  );
}
